import { render, staticRenderFns } from "./addedit.vue?vue&type=template&id=3edaf2dc&"
import script from "./addedit.vue?vue&type=script&lang=js&"
export * from "./addedit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports